export default __webpack_public_path__ + "static/media/mall-banner.ce537eab.jpg";